import type { IconName } from "@porsche-design-system/components-react"
import { PTable, PTableBody, PTableCell, PTableRow, PText } from "@porsche-design-system/components-react"
import { colorError } from "@porsche-design-system/components-react/emotion"
import type { DosOfferView } from "@slfinrtl/ui-bff-routes"
import { useIntl } from "react-intl"
import { ActionItem, Badge } from "src/components"
import { OfferListTableHead } from "./OfferListTableHead"
import { offerStatusMessages } from "./offerStatus.messages"

interface OfferOverviewProps {
	offers: DosOfferView[]
	onEditOfferClicked: (id: string) => void
}

export const OfferList = ({ offers, onEditOfferClicked }: OfferOverviewProps) => {
	const { formatMessage } = useIntl()
	return (
		<PTable data-testid="offer-overview" caption="Offer List" sticky>
			<OfferListTableHead />
			<PTableBody>
				{offers.map((offer) => (
					<PTableRow key={offer.id}>
						<PTableCell>{offer.businessPartnerId}</PTableCell>
						<PTableCell>{offer.ppnUserName}</PTableCell>
						<PTableCell>{offer.creationDate}</PTableCell>
						<PTableCell>{offer.code}</PTableCell>
						<PTableCell>{offer.customerType}</PTableCell>
						<PTableCell>{offer.tradeIn}</PTableCell>
						<PTableCell>
							<PText weight="bold">{offer.price}</PText>
						</PTableCell>
						<PTableCell>
							<ActionItem
								icon={offer.editOfferIcon as IconName}
								// TODO: use actual link
								onClick={() => onEditOfferClicked(offer.id)}
								view={offer.editOfferAction}
							/>
						</PTableCell>
						<PTableCell>
							{offer.state === "COMPLETED" && (
								<Badge label={formatMessage(offerStatusMessages.COMPLETED)} color={colorError} />
							)}
						</PTableCell>
					</PTableRow>
				))}
			</PTableBody>
		</PTable>
	)
}
